import {
    AuditModel,
    AuditsModel,
    LoggedIssueModel,
    TourHistoryModel,
    TourModel,
    UpdateTypeModel,
    VehicleEventsModel,
    VehicleModel,
} from "@core/services/api.service";
import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    SimpleChanges,
    Inject,
    ViewChild,
    OnChanges,
    ChangeDetectorRef,
} from "@angular/core";
import { DataSourceConfig } from "@core/models";
import { UntypedFormBuilder } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Actions, Select, Store, ofActionSuccessful } from "@ngxs/store";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort, Sort } from "@angular/material/sort";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { Observable } from "rxjs";
import { AuditState } from "@ngxs-store/audit-store/audit.state";
import {
    LoadAuditHistoryAction,
    LoadAuditsHistoryAction,
} from "@ngxs-store/audit-store/audit.actions";
import {
    ClearSelectedTourAction,
    CloseIssueAction,
    CreateTourHistoryByTourIdAction,
    DisableHistoryItemIdAction,
    DisableHistoryItemIdSuccessAction,
    GetRouteByTourIdAction,
    GetTourByIdAction,
    GetTourByIdSuccessAction,
    LoadLoggedIssuesAction,
    LoadLoggedIssuesSuccessAction,
    LoadTourUpdateHistoryAction,
    LoadTourUpdateHistorySuccessAction,
    UpdateETAAction,
    UpdateHistoryItemByIdAction,
} from "@ngxs-store/managed-tour-store/managed-tour.actions";
import { ManagedToursState } from "@ngxs-store/managed-tour-store/managed-tour.state";
import { VehiclesState } from "@ngxs-store/vehicles-store/vehicles.state";
import {
    GetVehicleEventsAction,
    GetVehicleLocFromEventAction,
} from "@ngxs-store/vehicles-store/vehicles.action";
import { LatLngLiteral } from "@agm/core";
import { RejectionDialogComponent } from "../rejection-dialog/rejection-dialog.component";
import { UpdateTypeState } from "@ngxs-store/update-type-store/update-type.state";
import { LoadUpdateTypesAction } from "@ngxs-store/update-type-store/update-type.actions";
import { AuthState } from "@ngxs-store/auth-store/auth.state";
import { map } from "rxjs/operators";
import { UpdateEtaDialogComponent } from "../update-eta-dialog/update-eta-dialog";
import { ROUTE_ANIMATIONS_ELEMENTS } from "@core/animations/route.animations";
import { Subject } from "@microsoft/signalr";
import { CreateEmailtrigger } from "@ngxs-store/email-trigger-store/email-trigger.actions";
import { ConfirmationDialogComponent } from "../confirmation-dialog/confirmation-dialog.component";

@Component({
    selector: "app-audit-history-dialog",
    templateUrl: "./audit-history-dialog.component.html",
    styleUrls: ["./audit-history-dialog.component.scss"],
})
export class AuditHistoryDialogComponent implements OnInit, OnChanges {
    @Select(VehiclesState.getVehicleEventsByTourId) vehicleHistory$: Observable<
        VehicleEventsModel[]
    >;
    @Input() vehicleHistory: VehicleEventsModel[];
    //@Select(ManagedToursState.getTourUpdateHistory) audits$: Observable<TourHistoryModel[]>;
    @Input() audits: TourHistoryModel[];
    @Select(VehiclesState.getVehicleLocFromEvent)
    vehicleLoc$: Observable<VehicleEventsModel>;
    @Input() vehicleLoc: VehicleEventsModel;
    @Select(UpdateTypeState.getUpdateTypes) updateTypes$: Observable<
        UpdateTypeModel[]
    >;
    @Input() updateTypes: UpdateTypeModel[];

    @Select(ManagedToursState.getLoggedIssues) loggedIssues$: Observable<
        LoggedIssueModel[]
    >;
    @Input() loggedAudits: LoggedIssueModel[];
    customerList: LoggedIssueModel[];
    @Input() isLoading: boolean;
    @Input() isMobileMode: boolean;
    @Input() id: number;
    lat: number;
    lng: number;
    mapCenter: LatLngLiteral = { lat: 48.858093, lng: 2.294694 };
    markers: Array<{ lat: number; lng: number }> = [];
    redPolylinePoints: Array<{ lat: number; lng: number }> = [];
    vehicleEventMarkers: VehicleEventsModel[] = [];
    vehicleEventPolylinePoints: Array<{ lat: number; lng: number }> = [];
    @Output() updateDataSourceConfig = new EventEmitter<DataSourceConfig>();
    @Output() dataSourceConfigChanged = new EventEmitter<DataSourceConfig>();
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    amcoId: number;
    dataSource: MatTableDataSource<VehicleEventsModel>;
    dataSource2: MatTableDataSource<TourHistoryModel>;
    dataSource3: MatTableDataSource<LoggedIssueModel>;
    dataSourceConfig$: Observable<DataSourceConfig>;

    displayedColumns: string[];
    displayedColumnsAdmin: string[] = [
        "updateType",
        "date",
        "updatedAt",
        "user",
        "note",
        "disabled",
        "approved",
        "rejectionComments",
        "actions",
    ];
    loggedIssuesColumns: string[] = [
        "updateType",
        "date",
        "isLoggedByCustomer",
        "user",
        "causeOfIssue",
        "impact",
        "reasonForIssue",
        "priority",
        "issueStatus",
        "actions",
    ];
    groupCollapsed: { [key: string]: boolean } = {};
    groupCounts: { [key: string]: number } = {};

    adminAudits: TourHistoryModel[];
    adminApproved: TourHistoryModel[];
    filterList: TourHistoryModel[];
    payload: any = {};
    tourId: number;
    hasManagerRole: boolean = false;
    hasUserCustomerRole: boolean = false;
    hasAdminRole: boolean = false;
    isCustomer: boolean = false;
    selectedTour: TourModel;
    routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

    detail: TourModel;
    vehicleDet: VehicleEventsModel;
    //collection and vehicleId
    collectionLat: number;
    collectionLng: number;
    imageUrl: string;

    dataSourceConfig: DataSourceConfig = {
        name: "audit-table",
        columns: [
            "positionDateTime",
            "address",
            "countryCode",
            "zipCode",
            "nearestCity",
        ],
        desktopModeColumns: [],
        mobileModeColumns: [],
        pageIndex: 10,
        pageSize: 10,
        pageSizeOptions: [10, 50, 100],
        filter: "",
        filterColumns: ["address", "countryCode"],
        selectedFilterColumns: ["address"],
        sortBy: "",
        sortByOrder: "",
    };

    private refreshDialogSubject = new Subject<void>();

    constructor(
        private formBuilder: UntypedFormBuilder,
        public dialogRef: MatDialog,
        private actions$: Actions,
        private cdr: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) data: any,
        private store: Store
    ) {
        const token = this.store.selectSnapshot(AuthState.getDecodedToken);
        if (
            token.roles.findIndex((hasRoleFn) => hasRoleFn === "Manager") > -1
        ) {
            this.hasManagerRole = true;
        } else {
            this.hasManagerRole = false;
        }
        //Admin role
        if (
            token.roles.findIndex(
                (hasRoleFn) => hasRoleFn === "Administrator"
            ) > -1
        ) {
            this.hasAdminRole = true;
        } else {
            this.hasAdminRole = false;
        }

        if (
            token.roles.findIndex(
                (hasRoleFn) =>
                    hasRoleFn === "Customer" || hasRoleFn === "CustomerAdmin"
            ) > -1
        ) {
            this.hasUserCustomerRole = true;
        } else {
            this.hasUserCustomerRole = false;
        }
        this.selectedTour = data.tour;
        this.id = data.id;
        this.amcoId = data.amcoId;
        this.tourId = data.tourId;
        this.isCustomer = data.isCustomer;

        this.displayedColumns = this.isCustomer
            ? ["icon", "updateType", "date", "note"]
            : ["icon", "updateType", "date", "updatedAt", "user", "note"];

        const sub1 = this.actions$
            .pipe(ofActionSuccessful(LoadLoggedIssuesSuccessAction))
            .subscribe((successAction: LoadLoggedIssuesSuccessAction) => {
                this.loggedAudits = successAction.payload.tours.filter(
                    (l) => !l.disabled
                );

                sub1.unsubscribe();
            });

        const actionSub = this.actions$
            .pipe(ofActionSuccessful(LoadTourUpdateHistorySuccessAction))
            .subscribe((successAction: LoadTourUpdateHistorySuccessAction) => {
                this.audits = successAction.payload.tourUpdateHistory;

                // First table
                this.filterList = this.audits.filter(
                    (audit) =>
                        audit.updateType !== "Escalation" && audit.updateType !== "Hypercare" && audit.updateType !== "Non-hypercare" &&
                        audit.updateType !== "Tracking Frequency" && (
                            (!audit.requiresValidation && !audit.disabled) ||
                            (audit.approved === true && !audit.disabled) ||
                            (audit.approved === null &&
                                !audit.disabled &&
                                audit.user !== "ImportService")
                        )
                );

                        this.filterList = this.applyBmwHistoryFlowIfNeeded(this.filterList);

                this.adminApproved = this.filterList.filter(
                    (audit) =>
                        audit.user !== "ImportService" &&
                        !audit.requiresValidation &&
                        (this.isCustomer
                            ? audit.updateType !== "Log an Issue"
                            : true)
                );

                // Second table
                this.adminAudits = this.audits.filter((audit) =>
                    this.isCustomer ? audit.updateType !== "Log an Issue" : true
                );
                this.adminAudits = this.applyBmwHistoryFlowIfNeeded(this.adminAudits);

                this.initializeGroups();
                actionSub.unsubscribe();
            });

        this.store.dispatch(new GetTourByIdAction(this.tourId));
        const sub = this.actions$
            .pipe(ofActionSuccessful(GetTourByIdSuccessAction))
            .subscribe((detail) => {
                this.detail = detail.payload;

                if (this.detail && this.detail.id) {
                    const id = this.detail.id;
                    this.lat = this.detail.destinationLatitude;
                    this.lng = this.detail.destinationLongitude;
                    this.markers.push({
                        lat: this.detail.destinationLatitude,
                        lng: this.detail.destinationLongitude,
                    });
                    this.collectionLat = this.detail.collectionLatitude;
                    this.collectionLng = this.detail.collectionLongitude;
                    this.markers.push({
                        lat: this.detail.collectionLatitude,
                        lng: this.detail.collectionLongitude,
                    });
                    // Get vehicle by vehicleId from tour
                    this.store.dispatch(
                        new GetVehicleLocFromEventAction(this.detail.id)
                    );

                    this.store
                        .select(VehiclesState.getVehicleLocFromEvent)
                        .subscribe((vehicleLoc) => {
                            this.vehicleDet = vehicleLoc;
                        });

                    //Get vehicle events & plot
                    this.store.dispatch(new GetVehicleEventsAction(id));
                    this.store
                        .select(VehiclesState.getVehicleEventsByTourId)
                        .subscribe((events) => {
                            this.redPolylinePoints = events.map((event) => ({
                                lat: event.latitude,
                                lng: event.longitude,
                            }));
                        });
                    this.redPolylinePoints.forEach((point) => {
                        this.markers.push(point);
                    });

                    if (this.markers.length) {
                        const sumLat = this.markers.reduce(
                            (sum, marker) => sum + marker.lat,
                            0
                        );
                        const sumLng = this.markers.reduce(
                            (sum, marker) => sum + marker.lng,
                            0
                        );

                        // Calculate the average latitude and longitude
                        this.mapCenter.lat = sumLat / this.markers.length;
                        this.mapCenter.lng = sumLng / this.markers.length;
                    } else {
                        this.mapCenter = { lat: 48.858093, lng: 2.294694 };
                    }
                }
                sub.unsubscribe();
            });

        this.store.dispatch(new LoadTourUpdateHistoryAction(this.id));
        this.store.dispatch(new GetVehicleEventsAction(this.id));
        this.store.dispatch(new LoadLoggedIssuesAction(this.id));

        this.dataSource = new MatTableDataSource(this.vehicleHistory);
        this.dataSource2 = new MatTableDataSource(this.audits);
        this.dataSource = new MatTableDataSource<VehicleEventsModel>(
            this.vehicleHistory
        );
        this.dataSource2 = new MatTableDataSource<TourHistoryModel>(
            this.audits
        );

        this.dataSource3 = new MatTableDataSource(this.loggedAudits);
        this.dataSource3 = new MatTableDataSource<TourHistoryModel>(
            this.loggedAudits
        );

        //Get vehicle events & plot
        this.store
            .select(VehiclesState.getVehicleEventsByTourId)
            .subscribe((events) => {
                this.redPolylinePoints = events.map((event) => ({
                    lat: event.latitude,
                    lng: event.longitude,
                }));
            });

        this.store.dispatch(new LoadUpdateTypesAction());

        this.updateTypes$.subscribe((types) => {
            this.updateTypes = types;
        });
    }

    ngOnInit() {
        this.dataSource = new MatTableDataSource<VehicleEventsModel>();
        this.dataSource2 = new MatTableDataSource<TourHistoryModel>();
        this.dataSource3 = new MatTableDataSource<LoggedIssueModel>();

        /* this.audits$.subscribe(audit => {
        this.audits = audit;
        this.dataSource2.data = audit;
    }); */

        this.vehicleHistory$.subscribe((vehicle) => {
            this.vehicleHistory = vehicle;
            this.dataSource.data = vehicle.filter(
                (vh) => vh.disabled == false || vh.disabled == null
            );
            this.updateVehicleEventMapLayers(vehicle);
        });
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.dataSource.filterPredicate = (
            data: VehicleEventsModel,
            filter: string
        ) => this.filterPredicate(data, filter);

        this.applyDataSourceConfig();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.audits && changes.audits.currentValue) {
            const audits: TourHistoryModel[] = changes.audits
                .currentValue as TourHistoryModel[];
            this.dataSource2.data = audits;
        }

        if (changes.vehicleHistory && changes.vehicleHistory.currentValue) {
            const vehicleHistory: VehicleEventsModel[] = changes.vehicleHistory
                .currentValue as VehicleEventsModel[];
            this.dataSource.data = vehicleHistory;
            this.updateVehicleEventMapLayers(vehicleHistory);
        }

        if (changes.loggedAudits && changes.loggedAudits.currentValue) {
            const loggedIssues: LoggedIssueModel[] = changes.loggedAudits
                .currentValue as LoggedIssueModel[];
            this.loggedAudits = loggedIssues;
        }

        if (changes.dataSourceConfig) {
            this.applyDataSourceConfig();
        }
    }

    initializeGroups() {
        this.groupCounts = this.adminApproved.reduce((acc, audit) => {
            acc[audit.groupId] = (acc[audit.groupId] || 0) + 1;
            return acc;
        }, {});
        this.groupCollapsed = Object.keys(this.groupCounts).reduce(
            (acc, key) => {
                acc[key] = true;
                return acc;
            },
            {}
        );
    }

    onCancelClick(): void {
        this.store.dispatch(new ClearSelectedTourAction());
        this.dialogRef.closeAll();
    }

    isFirstInGroup(audit: any, index: number): boolean {
        if (index === 0) return true;
        return this.adminApproved[index - 1].groupId !== audit.groupId;
    }

    toggleGroup(groupId: number) {
        this.groupCollapsed[groupId] = !this.groupCollapsed[groupId];
    }

    onMapReady(map: any): void {
        const trafficLayer = new google.maps.TrafficLayer();
        trafficLayer.setMap(map);
    }

    approveAudit(audit: any) {
        //Hit Update ETA on accept history item
        const restStartDateTime = new Date();
        const restEndDateTime = new Date();
        //Get update type based on history updatetype
        var selectedUpdateType = this.updateTypes.filter(
            (t) => t.name === audit.updateType
        );
        this.store.dispatch(
            new UpdateETAAction(
                this.tourId,
                new Date(audit.date),
                selectedUpdateType[0].id,
                audit.note,
                audit.updateType === "Input location" || "Driver Rest end"
                    ? audit.vehicleLat
                    : null, // vehicleLat
                audit.updateType === "Input location" || "Driver Rest end"
                    ? audit.vehicleLng
                    : null, // vehicleLng
                audit.updateType === "Input location" || "Driver Rest end"
                    ? audit.vehicleDur
                    : null, // vehicleDuration
                audit.updateType === "Input location" || "Driver Rest end"
                    ? audit.vehicleDistance
                    : null, // vehicleDistance
                audit.updateType === "Input location" || "Driver Rest end"
                    ? audit.place
                    : "", // places
                restStartDateTime,
                restEndDateTime,
                audit.id,
                this.selectedTour?.transportOrderNumber
            )
        );

        this.store.dispatch(new ClearSelectedTourAction());
        this.dialogRef.closeAll();
    }

    rejectAudit(audit: any) {
        // Implement the logic to reject the audit
        let dialog;
        dialog = this.dialogRef.open(RejectionDialogComponent, {
            data: {
                modalTitle: "Reject Update Changes",
                buttonType: "Reject",
            },
            width: "600px",
        });

        dialog.afterClosed().subscribe((result) => {
            if (result.result) {
                // hit the update history
                const rejectReason = result.reason;
                this.payload = {
                    tourId: audit.id,
                    note: audit.note,
                    isApproved: false,
                    requiresValidation: true,
                    rejectionComments: rejectReason,
                    eta: new Date(audit.date),
                    isEdit: false,
                };
                this.store.dispatch(
                    new UpdateHistoryItemByIdAction(this.payload)
                );
                this.store.dispatch(new ClearSelectedTourAction());
                this.dialogRef.closeAll();
            }
        });
    }

    onCloseClick(audit: any) {
        let dialog;
        dialog = this.dialogRef.open(ConfirmationDialogComponent, {
            data: {
                id: audit.id,
                tourId: this.tourId,
                modalTitle: `Close Issue`,
                buttonType: 'CloseIssue',
                confirmationText: `You are about to Close issue ?`
            },
        });

        dialog.afterClosed().subscribe(result => {
            if (result) {
                this.store.dispatch(new CloseIssueAction(audit.id, this.tourId));
            }
        });

        // Trigger change detection
        this.cdr.detectChanges();
        this.refresh();
    }

    editAudit(audit: any) {
        //Open Update ETA dialog and Edit
        //Get selected id on edit
        //Exception for updates
        if (audit.updateType === null || audit.updateType === undefined) {
            audit.updateType = "Log an Issue";
        }

        var updateTypeSelected = this.updateTypes.filter(
            (x) => x.name == audit.updateType
        );

        var typeSelected = updateTypeSelected[0]?.name;
        var typeId = updateTypeSelected[0]?.id;

        const dialog = this.dialogRef.open(UpdateEtaDialogComponent, {
            data: {
                tour: this.selectedTour,
                tourId: this.selectedTour.tourId,
                updateTypeId: typeId,
                updateTypeName: typeSelected,
                id: this.id,
                amcoId: this.selectedTour.amcoId,
                targetDate: this.selectedTour.targetDateTime,
                plannedDeliveryStart: this.selectedTour.plannedDeliveryStart,
                plannedDeliveryEnd: this.selectedTour.plannedDeliveryEnd,
                plannedLoadingStart: this.selectedTour.plannedLoadingStart,
                plannedLoadingEnd: this.selectedTour.plannedLoadingEnd,
                vehicleTypes: this.selectedTour.vechicleTypes,
                hasVehicle: this.selectedTour.vehicleId ? true : false,
                note:
                    audit.updateType === "Log an Issue"
                        ? audit.details
                        : audit.note, // note to edit
                combinedDate:
                    audit.updateType === "Log an Issue"
                        ? audit.estimatedDatetime
                        : audit.date, // combined date on edit
                historyId: audit.id, // history id to check for existing tour history
                causeOfIssue: audit.causeOfIssue,
                impact: audit.impact,
                reasonForIssue: audit.reasonForIssue,
                isLoggedByCustomer: audit.isLoggedByCustomer,
                managerActions: audit.managerActions,
                issueActions: audit.issueActions,
                priority: audit.priority,
                isEdit: true, // edit flag
            },
            width: "800px",
            disableClose: true,
        });

        dialog.afterClosed().subscribe((result) => {
            // Clear the tour cache when the update ETA dialog is closed
            this.store.dispatch(new ClearSelectedTourAction());
        });
    }

    triggerDialogRefresh() {
        this.refreshDialogSubject.next();
    }

    disableAudit(audit: any) {
        //disable history item
        this.store.dispatch(new DisableHistoryItemIdAction(audit.id, this.id));

        const disabledAction = this.actions$.pipe(ofActionSuccessful(DisableHistoryItemIdSuccessAction))
        .subscribe((successAction: DisableHistoryItemIdSuccessAction) => {
            this.store.dispatch(new LoadTourUpdateHistoryAction(this.id));

            disabledAction.unsubscribe();
        });


        const actionSub = this.actions$
            .pipe(ofActionSuccessful(LoadTourUpdateHistorySuccessAction))
            .subscribe((successAction: LoadTourUpdateHistorySuccessAction) => {
                this.audits = successAction.payload.tourUpdateHistory;

                // First table
                this.filterList = this.audits.filter(
                    (audit) =>
                        audit.updateType !== "Escalation" && (
                            (!audit.requiresValidation && !audit.disabled) ||
                            (audit.approved === true && !audit.disabled) ||
                            (audit.approved === null &&
                                !audit.disabled &&
                                audit.user !== "ImportService")
                        )
                );

                        this.filterList = this.applyBmwHistoryFlowIfNeeded(this.filterList);

                this.adminApproved = this.filterList.filter(
                    (audit) =>
                        audit.user !== "ImportService" &&
                        !audit.requiresValidation &&
                        (this.isCustomer
                            ? audit.updateType !== "Log an Issue"
                            : true)
                );

                // Second table
                this.adminAudits = this.audits.filter((audit) =>
                    this.isCustomer ? audit.updateType !== "Log an Issue" : true
                );
                this.adminAudits = this.applyBmwHistoryFlowIfNeeded(this.adminAudits);

                // Reinitialize the groups
                this.initializeGroups();

                // Trigger the refresh
                // Using Microsoft signalr import
                this.triggerDialogRefresh();

                //needed to refresh dialog without closing it
                //To-do: Test in QA
                this.cdr.detectChanges();

                actionSub.unsubscribe();
            });

        // Trigger change detection
        this.cdr.detectChanges();
        this.refresh();
    }

    refresh() {
        this.store.dispatch(new LoadLoggedIssuesAction(this.id));
        this.store.dispatch(new GetVehicleEventsAction(this.id));

        this.triggerDialogRefresh();
        this.cdr.detectChanges();

        const sub1 = this.actions$
            .pipe(ofActionSuccessful(LoadLoggedIssuesSuccessAction))
            .subscribe((successAction: LoadLoggedIssuesSuccessAction) => {
                this.loggedAudits = successAction.payload.tours.filter(
                    (l) => !l.disabled
                );

                sub1.unsubscribe();
            });

        this.triggerDialogRefresh();
        this.cdr.detectChanges();
    }

    getAuditHistoryUserDisplay(user: string | null | undefined): string {
        const value = (user || '').trim();
        if (!value) {
            return '';
        }

        return value === 'DriverIntUser' ? 'DriverAPP' : value;
    }

    private applyBmwHistoryFlowIfNeeded(list: TourHistoryModel[]): TourHistoryModel[] {
        if (!this.selectedTour?.isBmwJob || !list?.length) {
            return list;
        }

        const normalize = (value: string | null | undefined): string =>
            (value || '').toLowerCase().replace(/\s+/g, ' ').trim();

        const terminalStatusOrder = new Map<string, number>([
            ['tracking ended', 0],
            ['departed unloading point', 1],
            ['pod received', 2],
        ]);

        const getTerminalRank = (updateType: string | null | undefined): number => {
            const normalized = normalize(updateType);
            return terminalStatusOrder.has(normalized)
                ? (terminalStatusOrder.get(normalized) as number)
                : Number.MAX_SAFE_INTEGER;
        };

        const withoutAwaitingPod = list.filter(item => !normalize(item.updateType).includes('awaiting pod'));

        return [...withoutAwaitingPod].sort((a, b) => {
            const terminalRankA = getTerminalRank(a.updateType);
            const terminalRankB = getTerminalRank(b.updateType);
            if (terminalRankA !== terminalRankB) {
                return terminalRankA - terminalRankB;
            }

            const timeA = new Date(a.updatedAt as any).getTime();
            const timeB = new Date(b.updatedAt as any).getTime();
            if (Number.isNaN(timeA) && Number.isNaN(timeB)) {
                return 0;
            }
            if (Number.isNaN(timeA)) {
                return 1;
            }
            if (Number.isNaN(timeB)) {
                return -1;
            }
            return timeB - timeA;
        });
    }


    getTruckIcon(planned: string, eta?: Date, actual?: Date): string {
        const plannedDate = new Date(planned);
        const etaOrActual = eta || actual;

        if (!etaOrActual) {
            // No ETA or actual time entered
            return "./assets/images/amco-main-bw.png";
        }

        if (etaOrActual > plannedDate) {
            // ETA or actual time is after the planned time
            if (this.isCustomer) {
                return "./assets/images/amco-green-truck.png";
            } else {
                return "./assets/images/amco-red-truck.png";
            }
        }

        // ETA or actual time is before or on the planned time
        return "./assets/images/amco-green-truck.png";
    }

    getCollectionIcon(
        planned: string,
        eta?: Date,
        actual?: Date,
        type?: string
    ): string {
        const plannedDate = new Date(planned);
        const etaOrActual = eta || actual;
        const ActualDateTime = actual;
        const ETA = eta;

        if (!etaOrActual) {
            // No ETA or actual time entered
            return "./assets/images/collect-base.png";
        }

        if (type == "Delivery") {
            if (ActualDateTime > plannedDate) {
                // ETA or actual time is after the planned time
                return "./assets/images/collect-1.png";
            } else {
                return "./assets/images/collect-2.png";
            }
        }

        if (etaOrActual > plannedDate) {
            // ETA or actual time is after the planned time
            return "./assets/images/collect-1.png";
        }

        // ETA or actual time is before or on the planned time
        return "./assets/images/collect-2.png";
    }

    getDeliveryIcon(planned: string, eta?: Date, actual?: Date): string {
        const plannedDate = new Date(planned);
        const etaOrActual = eta || actual;

        if (!etaOrActual) {
            // No ETA or actual time entered
            return "./assets/images/delivery-base.png";
        }

        if (etaOrActual > plannedDate) {
            // ETA or actual time is after the planned time
            return "./assets/images/delivery-1.png";
        }

        // ETA or actual time is before or on the planned time
        return "./assets/images/delivery-2.png";
    }

    getTimeDifference(targetDateTime: string, ETADateTime: Date): string {
        const targetDate = new Date(targetDateTime);

        if (!ETADateTime) {
            //no eta then Delta should be blank
            return "";
        } else {
            // If ETA exists, calculate time difference between ETA and planned end
            const ETADate = new Date(ETADateTime);
            const timeDifference = Math.abs(
                ETADate.getTime() - targetDate.getTime()
            );
            const minutesDifference = Math.floor(timeDifference / (1000 * 60));

            const hours = Math.floor(minutesDifference / 60);
            const minutes = minutesDifference % 60;

            if (hours === 0 && minutes === 0) {
                return "0 hrs";
            }

            let timeDifferenceString = "";

            if (hours > 0) {
                timeDifferenceString += hours + "hr ";
            }
            if (minutes > 0) {
                timeDifferenceString += minutes + "min";
            }

            return timeDifferenceString.trim();
        }
    }

    private updateVehicleEventMapLayers(events: VehicleEventsModel[] = []): void {
        const sortedEvents = [...events]
            .filter((event) => event?.latitude != null && event?.longitude != null)
            .sort((a, b) => {
                const timeA = new Date(a.positionDateTime as any).getTime();
                const timeB = new Date(b.positionDateTime as any).getTime();

                if (Number.isNaN(timeA) && Number.isNaN(timeB)) {
                    return 0;
                }

                if (Number.isNaN(timeA)) {
                    return 1;
                }

                if (Number.isNaN(timeB)) {
                    return -1;
                }

                return timeA - timeB;
            });

        this.vehicleEventMarkers = sortedEvents;
        this.vehicleEventPolylinePoints = sortedEvents.map((event) => ({
            lat: event.latitude as number,
            lng: event.longitude as number,
        }));
    }

    getVehicleEventTitle(event: VehicleEventsModel): string {
        const parts: string[] = [];

        if (event.vehicleLicensePlate) {
            parts.push(`Reg: ${event.vehicleLicensePlate}`);
        }

        if (event.positionDateTime) {
            parts.push(`Date: ${new Date(event.positionDateTime as any).toLocaleString()}`);
        }

        if (event.nearestCity) {
            parts.push(`City: ${event.nearestCity}`);
        }

        if (event.addressInfo) {
            parts.push(`Address: ${event.addressInfo}`);
        }

        return parts.join("\n") || "Vehicle Event";
    }

    getVehicleUpdateType(updateType: string, note: string): boolean {
        if (
            updateType === "Other status" &&
            (note?.toLowerCase().includes("vehicle") || note?.toLowerCase().includes("trailer"))
        ) {
            return true;
        }
        return false;
    }

    applyDataSourceConfig() {
        if (this.dataSource.paginator) {
            this.dataSource.filter = this.dataSourceConfig.filter;
            this.dataSource.paginator.pageIndex =
                this.dataSourceConfig.pageIndex;
            this.dataSource.paginator.pageSize = this.dataSourceConfig.pageSize;
            this.dataSource.paginator.pageSizeOptions =
                this.dataSourceConfig.pageSizeOptions;
        }

        if (this.dataSource.sort) {
            this.dataSource.sort.direction = this.dataSourceConfig.sortByOrder;
            this.dataSource.sort.active = this.dataSourceConfig.sortBy;
        }
    }

    page(pageEvent: PageEvent) {
        this.updateDataSourceConfig.emit({
            ...this.dataSourceConfig,
            pageIndex: pageEvent.pageIndex,
            pageSize: pageEvent.pageSize,
        });
    }

    sortChange(sortEvent: Sort) {
        this.updateDataSourceConfig.emit({
            ...this.dataSourceConfig,
            sortByOrder: sortEvent.direction,
            sortBy: sortEvent.active,
        });
    }

    filterPredicate(data: TourHistoryModel, filter: string): boolean {
        if (this.dataSourceConfig.selectedFilterColumns.length > 0) {
            return this.dataSourceConfig.selectedFilterColumns.length === 1
                ? data[this.dataSourceConfig.selectedFilterColumns[0]]
                      .toString()
                      .toLowerCase()
                      .includes(filter.trim().toLowerCase())
                : this.dataSourceConfig.selectedFilterColumns
                      .reduce((prevVal, currVal, idx) => {
                          return idx === 1
                              ? data[prevVal] + data[currVal]
                              : prevVal + data[currVal];
                      })
                      .toString()
                      .toLowerCase()
                      .includes(filter.trim().toLowerCase());
        }
    }

    getIcon(type: string, updatedBy: string): string {
        if (updatedBy == "ImportService") {
            return type == "Collection"
                ? "./assets/images/White-C.png"
                : "./assets/images/White-D.png";
        } else {
            return type == "Collection"
                ? "./assets/images/Green-C.png"
                : "./assets/images/Green-D.png";
        }
    }
}
